import {
  object, any,
} from 'prop-types';

export const basePropTypes = {
  campaign: object,
  tnmProps: object,
  subscribeButton: any,
};
